import { GrTypography } from "@jnpmedi/grebob/dist/components/inputs/GrTypography";
import { GrDivider } from "@jnpmedi/grebob/dist/components/layout/GrDivider";
import { GrStack } from "@jnpmedi/grebob/dist/components/layout/GrStack";
import { MvnMessage } from "@newLibs/utils";
import { DOCS_DOCUMENT_SIGN_LANG } from "@maven-msg/lang/docs/documentSign";

interface SignRequestReasonLeftSideBarProps {
  requestReason: string;
}

export function CommonSignRequestReasonLeftSideBar({ requestReason }: SignRequestReasonLeftSideBarProps) {
  return (
    <>
      <GrStack style={{ padding: "0 16px 0", width: "100%" }} flexDirection="column" gap={8}>
        <GrTypography type="Content.Subtitle04" color="grey050">
          {MvnMessage(DOCS_DOCUMENT_SIGN_LANG.DOCUMENT_SIGN_EMAIL_REQUEST_REASON)}
        </GrTypography>
        <GrTypography type="Content.Body04" color="grey080">
          {requestReason}
        </GrTypography>
      </GrStack>
      <GrDivider spacing={12} />
    </>
  );
}
